import React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';

interface Props {
  name: string;
}

export const ParticipantInfo = ({ name }: Props) => {
  return (
    <Stack direction="row" alignItems="center" gap="0.5rem">
      <Avatar sx={{ width: '1.5rem', height: '1.5rem' }} />
      <Typography variant="body1">{name}</Typography>
    </Stack>
  );
};
